export default {
  careersRow1: '',
  careersRow2: '杰为客户希望杰为是工业软件领域的专家，加快数字化转型之路。为了持续推进客户的转型，我们与全球最有远见的制造商合作，聘请足够专业与创新的员工。我们的成功，不仅在于技术，更有赖于杰为团队的力量。',
  careersRow3: '复制成功，请到微信聊天界面，粘贴分享职位信息',
  careersRow4: '',
  careersRow5: '',
  careersRow6: '',
  careersRow7: '深圳',
  careersRow8: '职位名',
  careersRow9: '职位描述',
  careersRow10: '工作地',
  careersRow11: '联系方式',
  careersRow12: '分享',
  careersRow13: '1、达成销售任务目标，与客户建立良好的长期合作关系；',
  careersRow14: '2、负责销售合同的谈判与签订，并监督产品实施过程，直至项目成功交付；',
  careersRow15: '3、本科及以上学历，3年以上企业管理软件、工业设备或系统类产品销售经验，熟悉华东/华南区域市场。',
  careersRow16: '1、负责PLM项目的售前咨询，包括需求调研、方案设计、产品演示及SOW撰写等，完成招投标相关文档资料的筹备；',
  careersRow17: '2、协助市场和销售人员进行PLM业务拓展；',
  careersRow18: '3、本科及以上学历，2年以上产品设计、研发、工艺等某一领域经验，熟悉一种以上市场主流的CAD/PDM/PLM系统。',
  careersRow19: '1、负责前端架构的框架或核心模块的设计与实现，并进行技术培训和合作指导；',
  careersRow20: '2、制定前端开发的标准和规范，并推广应用，提高团队的开发效率；',
  careersRow21: '3、本科及以上学历，理工科相关专业, 3年以上大前端架构开发经验；',
  careersRow22: '4、熟悉HTML5、CSS3开发技术，熟悉react、vue等主流开发框架，熟悉webpack等前端打包工具，熟悉nodejs，熟练掌握各种前端管理框架。',
  careersRow23: '1、负责完成项目交付，包括与售前团队的项目 Handover、项目计划执行/范围控制/资源成本管理/验收回款/风险管控等，保证客户满意度；',
  careersRow24: '2、协助销售和解决方案团队，挖掘获取新的商业机会；协助研发中心，改进提升产品迭代；',
  careersRow25: '3、本科及以上学历，3 年以上软件产品开发或交付类多项目管理经验。',
  careersRow26: '大客户销售',
  careersRow27: '售前顾问',
  careersRow28: '前端架构师',
  careersRow29: '客户经理',
  careersRow30: '甘小姐',
  careersRow31: ''
}
